import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// cart product count
export const getWebOrder = createAsyncThunk(
  "order/customers-order",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    console.log("data", data);

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/webapp/orders/api/v1/customers-order/${localStorage.getItem(
          "customerId"
        )}`,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("cart product getWebOrder response ", response);
      return response; // ✅ Return only the data
    } catch (error) {
      console.error("Error fetching getWebOrder:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "error in cart getWebOrder"
      );
    }
  }
);

// get single sale order

export const getSingleOrder = createAsyncThunk(
  "client/get-sales-order",
  async (data, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");
    console.log("data", data);

    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/webapp/orders/api/v1/get-sales-order/${data}`,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("get single sale order response ", response);
      return response;
    } catch (error) {
      console.error("Error fetching getSingleSaleOrder:", error);

      // ✅ Handle errors properly
      return rejectWithValue(
        error.response?.data?.message || "error in getSingleSaleOrder"
      );
    }
  }
);
